// removed by extract-text-webpack-plugin
module.exports = {"container":"_2uyEEc4Cx0E11snidAhFNB","callInfo":"Z4b5NIbAk7hDHvMPB_QqK"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22f1eaeb","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Home/RecentActivity.less
// module id = jS04
// module chunks = 1